export default class UnloadRoutingGroupAdmin {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.gateways.agentProfile.unsubscribeAll();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/routing_groups/unload_routing_group_admin.js